import React, { useEffect } from "react";
import {
  DownloadButton,
  TopHeading,
  Wrapper,
} from "../../../common/index.style";
import SettlementsDataTableAG from "../../../components/table/SettlementsDataTableAG";
import { DataContent } from "../publishers/index.style";
import { useDispatch, useSelector } from "react-redux";
import { getAllSettlements } from "../../../redux/settlementSlice";
import { CSVLink } from "react-csv";
import { csvSettlementData } from "../../../utils/helper";
import { Row, Col } from "antd";

const Settlements = () => {
  const dispatch = useDispatch();

  const store = useSelector((store) => store);
  useEffect(() => {
    dispatch(getAllSettlements());
  }, [dispatch]);

  const { allSettlements, loading } = store.settlement;

  const data = csvSettlementData(allSettlements ?? []);
  return (
    <Wrapper>
      <Row justify="space-between" align="middle" style={{ marginBottom: 24 }}>
        <Col>
          <TopHeading style={{ margin: 0 }}>Settlements</TopHeading>
        </Col>
        <Col>
          <CSVLink filename="settlements" data={data}>
            <DownloadButton>Download</DownloadButton>
          </CSVLink>
        </Col>
      </Row>
      <DataContent>
        <SettlementsDataTableAG
          settlements={allSettlements}
          loading={loading}
        />
      </DataContent>
    </Wrapper>
  );
};

export default Settlements;
